import {AppConfigService} from '../services/appConfig.service';
import {IAppConfig} from '../../store/interfaces/IAppConfig';

export const APP_CONFIG = 'AppConfig';
export const getAppConfig = (appConfigService: AppConfigService): IAppConfig => {
  return appConfigService.getAppConfig();
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/config/app.config.ts